// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iEiBG","buttonOrange":"Button_buttonOrange__LVxN5","buttonWhite":"Button_buttonWhite__N6C0I"};